import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { CreditScoreOverviewItemModel, CreditUsageOverviewItemModel } from '../types'

interface CreditOverviewState {
    loadingCreditUsage: boolean
    loadingCreditScore: boolean
    creditUsageOverview: CreditUsageOverviewItemModel[]
    creditScoreOverview: CreditScoreOverviewItemModel[]
    error: Error | string | null
}

const initialState: CreditOverviewState = {
    loadingCreditUsage: false,
    loadingCreditScore: false,
    creditUsageOverview: [],
    creditScoreOverview: [],
    error: null
}

export const creditOverviewSlice = createSlice({
    name: 'creditOverview',
    initialState,
    reducers: {
        loadingCreditUsage: state => {
            state.loadingCreditUsage = true
            state.error = null
        },
        loadingCreditScore: state => {
            state.loadingCreditScore = true
            state.error = null
        },
        creditUsageOverviewFetched: (state, action: PayloadAction<CreditUsageOverviewItemModel[]>) => {
            state.loadingCreditUsage = false
            state.creditUsageOverview = action.payload
            state.error = null
        },
        creditUsageOverviewFetchFailure: (state, action: PayloadAction<Error | string>) => {
            state.loadingCreditUsage = false
            state.error = action.payload
        },
        creditScoreOverviewFetched: (state, action: PayloadAction<CreditScoreOverviewItemModel[]>) => {
            state.loadingCreditScore = false
            state.creditScoreOverview = action.payload
            state.error = null
        },
        creditScoreOverviewFetchFailure: (state, action: PayloadAction<Error | string>) => {
            state.loadingCreditScore = false
            state.error = action.payload
        },
    }
})

export const { 
    loadingCreditUsage, 
    loadingCreditScore,
    creditUsageOverviewFetched, 
    creditUsageOverviewFetchFailure,
    creditScoreOverviewFetched,
    creditScoreOverviewFetchFailure
} = creditOverviewSlice.actions

export default creditOverviewSlice.reducer